import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { PolicyActions } from "./policy.actions";
import { PoliciesService } from "@app/shared/services/policies.service";
import { ToastService } from "@app/core/services/toast.service";

@Injectable()
export class PolicyEffects {
  getPolicy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolicyActions.getPolicy),
      switchMap(({ policyId }) =>
       this.policiesService.getPolicyById(policyId).pipe(
          map(response => PolicyActions.getPolicySuccess({ policy : response.data })),
          catchError(error => of(PolicyActions.getPolicyFailure({ errors: error.error }))),
        ),
      ),
    ),
  );

  exportOneCoi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolicyActions.exportOneCOI),
      switchMap(({ request, policyId }) =>
        this.policiesService.exportOneCoi(request, policyId).pipe(
          map(() => {
            this.toastService.showInfo('Bulk COI Export has been started. You\'ll be notified when finished');
            return PolicyActions.exportCOISuccess();
          }),
          catchError(error => of(PolicyActions.exportCOIFailure({ errors: error.error }))),
        ),
      ),
    ),
  );

  exportBatchCoi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PolicyActions.exportBatchCOI),
      switchMap(({ request, policyId }) =>
        this.policiesService.exportBatchCoi(request, policyId).pipe(
          map(() => {
            this.toastService.showInfo('Bulk COI Export has been started. You\'ll be notified when finished');
            return PolicyActions.exportCOISuccess();
          }),
          catchError(error => of(PolicyActions.exportCOIFailure({ errors: error.error }))),
        ),
      ),
    ),
  );

  constructor(
    private readonly actions$: Actions,
    private readonly policiesService: PoliciesService,
    private readonly toastService: ToastService
  ) {}
}
